"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingTool = void 0;
const drawingToolOptions_1 = require("./options/drawingToolOptions");
const genericTool_1 = require("./genericTool");
class DrawingTool extends genericTool_1.GenericTool {
    constructor(options) {
        super(drawingToolOptions_1.DrawingToolOptions, options);
    }
    activate(annotator) {
        super.activate(annotator);
        this.annotator.canvas.isDrawingMode = true;
        this.annotator.canvas.freeDrawingBrush.color = this.options.color;
        this.annotator.canvas.freeDrawingBrush.width = this.options.width;
    }
    deactivate() {
        this.annotator.canvas.isDrawingMode = false;
        super.deactivate();
    }
    onMouseUp() {
        return true;
    }
}
exports.DrawingTool = DrawingTool;
